export default "__VITE_ASSET__c5cb2c82__"